import { useMemo } from "react";
import type { TemplateConfig } from "../../../config/templateConfig";
import {
  Target, TrendingUp, Smartphone, Zap, Code, Globe,
  Headphones, Rocket, Shield, BarChart, Lightbulb, FileCheck,
} from "lucide-react";

import ModernTemplate from "../templates/ModernTemplate";
import ClassicTemplate from "../templates/ClassicTemplate";
import MinimalTemplate from "../templates/MinimalTemplate";
import InfographicTemplate from "../templates/InfographicTemplate";

interface Props {
  proposal: any;
  templateConfig: TemplateConfig;
  scale?: number;
}

const dynamicIconMap: Record<string, any> = {
  brand: Target, branding: Target, identity: Target,
  engagement: TrendingUp, conversion: TrendingUp, growth: TrendingUp,
  speed: Zap, performance: Zap, optimization: Zap,
  mobile: Smartphone, responsive: Smartphone,
  development: Code, fullstack: Code, backend: Code, frontend: Code,
  seo: Globe, search: Globe, visibility: Globe,
  support: Headphones, maintenance: Headphones,
  launch: Rocket, deployment: Rocket,
  security: Shield, protection: Shield,
  analytics: BarChart, data: BarChart,
  ui: Lightbulb, ux: Lightbulb, design: Lightbulb,
  funnel: FileCheck, lead: FileCheck,
};

const getIconFromKeyword = (text: string) => {
  if (!text) return Target;
  const lower = text.toLowerCase();
  for (const key in dynamicIconMap) {
    if (lower.includes(key)) return dynamicIconMap[key];
  }
  return Target;
};

const LivePreview = ({ proposal, templateConfig, scale = 1 }: Props) => {
  const templateId = templateConfig.id;

  const templateProposal = useMemo(() => ({
    ...proposal,
    fullName: proposal.fullName || "Irfan Baig",
    tagline: proposal.tagline || "",
    profileImage: proposal.profileImage || "",
    stats: proposal.stats || [
      { value: "100%", label: "JOB SUCCESS" },
      { value: "50+", label: "PROJECTS COMPLETED" },
      { value: "5★", label: "CLIENT RATING" },
      { value: "<4hrs", label: "RESPONSE TIME" },
    ],
    links: proposal.links || [],
    sections: proposal.sections || [],
  }), [proposal]);

  const wrapperStyle: React.CSSProperties = {
    transform: scale !== 1 ? `scale(${scale})` : undefined,
    transformOrigin: "top left",
    width: scale !== 1 ? `${100 / scale}%` : "100%",
    minHeight: scale !== 1 ? `${100 / scale}%` : "100%",
    overflow: "hidden",
  };

  return (
    <div style={wrapperStyle}>
      {templateId === "infographic" ? (
        <InfographicTemplate proposal={templateProposal} mode="preview" />
      ) : templateId === "classic" ? (
        <ClassicTemplate proposal={templateProposal} getIconFromKeyword={getIconFromKeyword} />
      ) : templateId === "minimal" ? (
        <MinimalTemplate proposal={templateProposal} />
      ) : (
        <ModernTemplate proposal={templateProposal} />
      )}
    </div>
  );
};

export default LivePreview;
